import { BlueprintApiItem } from '../../../../api/core'
import { getTranslatedName } from './metricUtils'

// GR-2916 ships artist / icons / sometimes gameNames on the game-blueprint
// list. When every row already has those, we can skip `games/{ids}` and the
// full tracked-games list.

export function gameLevelBlueprintDisplayName(gameNames: BlueprintApiItem['gameNames'], userLanguage: string): string {
  if (!gameNames) return ''
  return getTranslatedName(gameNames, userLanguage) || Object.values(gameNames).find((value) => Boolean(value)) || ''
}

/** The icon a game-blueprint row shows: the first of the mobile `gameIcons`, else `gameIcon` (the only one PC/console games have). */
export function gameIconUrlOf(item: Pick<BlueprintApiItem, 'gameIcon' | 'gameIcons'>): string | undefined {
  return item.gameIcons?.[0] ?? item.gameIcon?.url
}

export function gameLevelBlueprintHasDisplayFields(item: BlueprintApiItem, userLanguage: string): boolean {
  const hasName = Boolean(gameLevelBlueprintDisplayName(item.gameNames, userLanguage))
  const hasArtist = Boolean(item.artist)
  const hasIcon = Boolean((item.gameIcons && item.gameIcons.length > 0) || item.gameIcon)
  return hasName && hasArtist && hasIcon
}
